import { IconButton, Tooltip, useBoolean } from "@aurem/ui";
import { SearchIcon } from "lucide-react";
import { useI18n } from "providers/I18nProvider";
import { GlobalSearchDialog } from "../index";

export const GlobalSearchToggle = () => {
  const { t } = useI18n();
  const {
    value: open,
    setTrue: handleOpen,
    setFalse: handleClose,
  } = useBoolean(false);

  return (
    <>
      <Tooltip content={t("apps.admin.common.search")}>
        <IconButton
          variant="ghost"
          color="neutral"
          onClick={handleOpen}
          className="search-tour-step" /* eslint-disable-line tailwindcss/no-custom-classname */
        >
          <SearchIcon className="rtl:-scale-x-100" size="1.5rem" />
        </IconButton>
      </Tooltip>
      <GlobalSearchDialog open={open} onDismiss={handleClose} />
    </>
  );
};
